import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Vaccine Names', value: data.name, fullWidth: true },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={`Day ${data.day}`}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
